import CollapsibleSection from "components/Section";
import { Button } from "components/Button";
import React, { useEffect, useState } from "react";
import TextValue from "components/TitleValue";
import { useTranslation } from "react-i18next";
import { TWaterSubscriber } from "types/dto";
import { Controller, useForm } from "react-hook-form";
import { TextField } from "@mui/material";
import { Permission } from "components/Permission";

type TProps = {
  data?: TWaterSubscriber;
  isLoading: boolean;
  onSaveClick: (e: TEditFormTypes) => void;
  isButtonLoading: boolean;
  enableEditing?: boolean;
  onEditClick?: () => void;
};
export type TEditFormTypes = {
  floorNo: number;
  unitNo: string;
  identifierId: string;
  subscriberName: string;
  nationalId: string;
  phoneNumber: string;
  mobileNumber: string;
  postalCode: string;
  email: string;
};
export const SubscriberInfo = (props: TProps) => {
  const {
    data,
    isLoading,
    onSaveClick,
    isButtonLoading,
    enableEditing,
    onEditClick,
  } = props;

  const { t } = useTranslation();

  // const [enableEditing, setEnableEditing] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    getValues,
  } = useForm<TEditFormTypes>({
    defaultValues: undefined,
  });

  useEffect(() => {
    if (data) {
      setValue("unitNo", data.unitNo);
      setValue("email", data.email);
      setValue("floorNo", data.floorNo);
      setValue("identifierId", data.identifierId);
      setValue("mobileNumber", data.mobileNumber);
      setValue("nationalId", data.nationalId);
      setValue("subscriberName", data.subscriberName);
      setValue("phoneNumber", data.phoneNumber);
      setValue("postalCode", data.postalCode);
    }
  }, [data]);

  return (
    <CollapsibleSection
      title={t("userInfo")}
      collapsible={false}
      isLoading={isLoading}
      skeleton="text"
    >
      <div className="flex flex-col w-full gap-y-3">
        <div className={"flex w-full gap-x-2"}>
          <Controller
            name={"subscriberName"}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("subscriberName")}
                  placeholder={t("subscriberName")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"flex-1"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
          <Controller
            name={"nationalId"}
            control={control}
            rules={
              {
                // required: true,
              }
            }
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("nationalId")}
                  placeholder={t("nationalId")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"flex-1"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
        </div>
        <div className={"flex w-full gap-x-2"}>
          <Controller
            name={"phoneNumber"}
            control={control}
            rules={
              {
                // required: true,
              }
            }
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("phoneNumber")}
                  placeholder={t("phoneNumber")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-1/2"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
          <Controller
            name={"mobileNumber"}
            control={control}
            rules={
              {
                // required: true,
              }
            }
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("mobileNumber")}
                  placeholder={t("mobileNumber")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-1/2"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
        </div>
        <div className={"flex w-full gap-x-2"}>
          <Controller
            name={"postalCode"}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("postalCode")}
                  placeholder={t("postalCode")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-1/2"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
          <Controller
            name={"email"}
            control={control}
            rules={
              {
                // required: true,
              }
            }
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("email")}
                  placeholder={t("email")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-1/2"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
        </div>
        <div className={"flex w-full gap-x-2"}>
          <Controller
            name={"unitNo"}
            control={control}
            rules={
              {
                // required: true,
              }
            }
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("unitNo")}
                  placeholder={t("unitNo")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-1/2"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
          <Controller
            name={"floorNo"}
            control={control}
            rules={
              {
                // required: true,
              }
            }
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("floorNo")}
                  placeholder={t("floorNo")}
                  size="small"
                  type="number"
                  {...field}
                  error={Boolean(error)}
                  className={"w-1/2"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
        </div>
        <div className={"flex w-full gap-x-2"}>
          <Controller
            name={"identifierId"}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("subscriberIdentifierId")}
                  placeholder={t("subscriberIdentifierId")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-1/2"}
                  InputLabelProps={{
                    shrink: !!field.value,
                  }}
                  disabled={!enableEditing}
                />
              );
            }}
          />
        </div>
      </div>
      {/*<div className={"grid grid-cols-2 gap-y-3 gap-x-6"}>*/}
      {/*  <TextValue*/}
      {/*    title={t("subscriberName")}*/}
      {/*    value={data?.subscriberName}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("floorNo")}*/}
      {/*    value={data?.floorNo}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("unitNo")}*/}
      {/*    value={data?.unitNo}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("identifierId")}*/}
      {/*    value={data?.identifierId}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("nationalId")}*/}
      {/*    value={data?.nationalId}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("phoneNumber")}*/}
      {/*    value={data?.phoneNumber}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("mobileNumber")}*/}
      {/*    value={data?.mobileNumber}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("postalCode")}*/}
      {/*    value={data?.postalCode}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*  <TextValue*/}
      {/*    title={t("email")}*/}
      {/*    value={data?.email}*/}
      {/*    className={"col-span-1"}*/}
      {/*  />*/}
      {/*</div>*/}
      <div className="w-full flex items-center justify-end mt-4">
        {enableEditing ? (
          <Button
            variant="contained"
            type={"submit"}
            onClick={() => {
              handleSubmit(onSaveClick)();
            }}
            loading={isButtonLoading}
          >
            {t("save")}
          </Button>
        ) : (
          <Permission allowed={["superadmin", "d_watersubscriber"]}>
            <Button variant="outlined" onClick={onEditClick}>
              {t("edit")}
            </Button>
          </Permission>
        )}
      </div>
    </CollapsibleSection>
  );
};
